module.exports = __webpack_public_path__ + "img/pin3.f44e3799.svg";